import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from 'lucide-react';
import { serviceCategories } from '../data/serviceCategories';
export function MobileServicesNav({
  isActive
}: {
  isActive: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [openCategory, setOpenCategory] = useState<string | null>(null);
  return <div className="border-b border-white/5" data-id="element-275" data-mp="iqbjlf0vgcmb">
      <div className="flex items-center justify-between" data-id="element-276" data-mp="4rvettmkkw6t">
        <Link to="/services" className={`flex-1 py-3.5 text-sm font-semibold uppercase tracking-[0.08em] ${isActive ? 'text-brand-light' : 'text-chalk/80'}`} data-id="element-277" data-mp="9rzwhmz7rwym">
          Services
        </Link>
        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Hide service categories' : 'Show service categories'} className="flex h-10 w-10 items-center justify-center text-chalk/60" data-id="element-278" data-mp="3w09c4rjbsmbb">
          <ChevronDownIcon className={`h-5 w-5 transition-transform duration-150 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-279" data-mp="3avl1uftq3lu0" />
        </button>
      </div>

      {open && <ul className="pb-3" data-id="element-280" data-mp="3fo4hrjfvut1z">
          {serviceCategories.map(category => {
        const expanded = openCategory === category.slug;
        return <li key={category.slug} className="border-t border-white/5" data-id="element-281" data-mp="2s0e63c22vpeb">
                <div className="flex items-center justify-between" data-id="element-282" data-mp="2n0ib22bcz8aw">
                  <Link to={`/services/${category.slug}`} className="flex-1 py-3 pl-3 text-[13.5px] font-medium text-chalk/70" data-id="element-283" data-mp="30zhrwnsmqiwi">
                    {category.name}
                  </Link>
                  <button type="button" onClick={() => setOpenCategory(expanded ? null : category.slug)} aria-expanded={expanded} aria-label={`${expanded ? 'Hide' : 'Show'} ${category.name} services`} className="flex h-9 w-9 items-center justify-center text-chalk/40" data-id="element-284" data-mp="g6xu6nok9kci">
                    <ChevronDownIcon className={`h-4 w-4 transition-transform duration-150 ease-out ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-285" data-mp="3j041ficv7hox" />
                  </button>
                </div>
                {expanded && <ul className="pb-2 pl-6" data-id="element-286" data-mp="302j9u3ipu50m">
                    {category.services.map(service => <li key={service.slug} data-id="element-287" data-mp="23kn3y8qnq2g4">
                        <Link to={`/services/${category.slug}/${service.slug}`} className="block py-2 text-[13px] leading-snug text-chalk/60" data-id="element-288" data-mp="23jvhbnf1ff1z">
                          {service.name}
                        </Link>
                      </li>)}
                  </ul>}
              </li>;
      })}
        </ul>}
    </div>;
}